import { lazyBg } from './modules/lazy-bg';
import { lazyLoad } from './modules/lazy-load';
import { navigation } from './modules/navigation';
import { smoothScroll } from './modules/smooth-scroll';
import { validation } from './modules/validation';
import { recaptchaDelay } from './modules/recaptcha-delay';
import { jobOffers } from './modules/job-offers';
import { fileInput } from './modules/file-input';
import { agreementToggle } from './modules/agreement-toggle';

function init() {
  lazyBg.init();
  lazyLoad.init();
  navigation.init();
  smoothScroll.init();
  validation.init();
  recaptchaDelay.init();
  jobOffers.init();
  fileInput.init();
  agreementToggle.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
